/**
 * Custom Domain (BYOD) — standalone page at /custom-domain.
 *
 * Page chrome (page-header + title + subtitle) lives here; the card
 * owns the wizard + status UX. Same gating shape every other gated
 * module uses — features.customDomain && plan === 'pro', enforced
 * server-side in lambda/routes/domains.ts.
 */

import { useAuth } from '../contexts/AuthContext';
import CustomDomainCard from '../components/CustomDomainCard';
import './CustomDomain.css';

function CustomDomain() {
  const { clubId, plan } = useAuth();
  return (
    <div className="custom-domain-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Custom Domain</h1>
          <p className="page-subtitle">
            Run your website on a domain you own.
          </p>
        </div>
      </div>
      <CustomDomainCard clubId={clubId} plan={plan} />
    </div>
  );
}

export default CustomDomain;
